import React, { Component } from 'react';
import styled from 'styled-components';
import { Layout, Dropdown, Space, Modal, Tag } from 'antd';
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { withRouter } from "react-router-dom";
const { Header } = Layout;
const Wrapper = styled.div`
  position: relative;
  .top {
    padding: 0;
    line-height: normal;
    background-color: #ffffff;
    .user {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
    }
  }
`;

class Top extends Component {

  logOut = () => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '是否退出登录？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        localStorage.removeItem('userInfo');
        this.props.history.replace('/login');
      }
    });
  }

  render() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const items = [
      {
        key: 1,
        label: <div onClick={this.logOut}>退出登录</div>
      }
    ];

    return (
      <Wrapper>
        <Header className="top">
          <Dropdown className="user" menu={{items}}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                {userInfo.username}
                { userInfo.roleNames.map((o, index) => <Tag key={index} color="#AF1F21">{o}</Tag>) }
                <Tag color="blue">{userInfo.kdtName}</Tag>
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        </Header>
      </Wrapper>
    );
  }
 }

export default withRouter(Top);
